import React, { useEffect, useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import { MdArrowForwardIos } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useCareTeamContext } from "../../Context/CareTeamContext";
import { getPatientListCareTeam } from "../../services/CareTeam";

const CareTeamBox = ({ setModalOpen }) => {
  const navigate = useNavigate();
  const {
    allTeams,
    getAssignedGroupPrograms,
    renderGroupSignal,
    renderProgramSignal,
    renderProviderSignal,
  } = useCareTeamContext();
  const [allGroups, setAllGroups] = useState();
  const [allPrograms, setAllPrograms] = useState();
  const [allProviders, setAllProviders] = useState();

  useEffect(() => {
    const getProviderList = async () => {
      const response = await getPatientListCareTeam();
      if (response.status !== 200) return;
      setAllProviders(response?.data?.data);
    };

    getProviderList();
  }, []);

  useEffect(() => {
    if (renderProviderSignal) {
      const getProviderList = async () => {
        const response = await getPatientListCareTeam();
        if (response.status !== 200) return;
        setAllProviders(response?.data?.data);
      };

      getProviderList();
    }
  }, [renderProviderSignal]);

  useEffect(() => {
    if (renderGroupSignal || renderProgramSignal) {
      const getData = () => {
        Promise.all([
          getAssignedGroupPrograms("group"),
          getAssignedGroupPrograms("program"),
        ])
          .then(([allGroup, allProgram]) => {
            // Handle the resolved values of both promises here
            // console.log("All groups:", allGroup);
            // console.log("All programs:", allProgram);

            // Now, you can return them or use them as needed
            setAllGroups(allGroup);
            setAllPrograms(allProgram);
          })
          .catch((error) => {
            // Handle errors if any of the promises reject
            console.error("Error:", error);
          });
      };
      getData(); //
    }
  }, [renderGroupSignal, renderProgramSignal]);

  useEffect(() => {
    const getData = () => {
      Promise.all([
        getAssignedGroupPrograms("group"),
        getAssignedGroupPrograms("program"),
      ])
        .then(([allGroup, allProgram]) => {
          // Handle the resolved values of both promises here
          // console.log("All groups:", allGroup);
          // console.log("All programs:", allProgram);

          // Now, you can return them or use them as needed
          setAllGroups(allGroup);
          setAllPrograms(allProgram);
        })
        .catch((error) => {
          // Handle errors if any of the promises reject
          console.error("Error:", error);
        });
    };
    getData(); //
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <div className="careteam_box13 carebox_back1 text-center pt-4 mb-4">
            <h2 className="mt-2 labelFont">{allTeams?.length}</h2>
            <h5 className="chidHeadFont">Teams</h5>
            <div
              className="text-end"
              data-bs-toggle="modal"
              data-bs-target="#createviewteam"
              onClick={setModalOpen}
            >
              <BsPlusLg className="icon me-4 mt-3" />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="careteam_box13 carebox_back2 text-center pt-4 mb-4">
            <h2 className="mt-2 labelFont">{allProviders?.length}</h2>
            <h5 className="chidHeadFont">Providers</h5>
            <div
              className="text-end"
              data-bs-toggle="modal"
              data-bs-target="#addproviders"
            >
              <BsPlusLg className="icon me-4 mt-3" />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div
            className="careteam_box13 carebox_back3 text-center pt-4 mb-4 pointer"
            onClick={() =>
              navigate("/viewcareteamgroups", { state: { careId: "" } })
            }
          >
            <h2 className="mt-2 labelFont">
              {allGroups?.length > 0 ? allGroups?.length : 0}
            </h2>
            <h5 className="chidHeadFont">Groups</h5>
            <div className="text-end">
              <MdArrowForwardIos className="icon me-4 mt-3" />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div
            className="careteam_box13 carebox_back4 text-center pt-4 mb-4 pointer"
            onClick={() =>
              navigate("/viewcareteamprograms", { state: { careId: "" } })
            }
          >
            <h2 className="mt-2 labelFont">
              {allPrograms?.length > 0 ? allPrograms?.length : 0}
            </h2>
            <h5 className="chidHeadFont">Programs</h5>
            <div className="text-end">
              <MdArrowForwardIos className="icon me-4 mt-3" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CareTeamBox;
